import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from "@angular/router";

@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.css']
})
export class CompanySelectComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

Company:any;

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router,  private _snackBar: MatSnackBar) { 

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

  }

  User:any;
  NoCompanyAssignedError:boolean = false;
  HasAppAccess:boolean = false;

  ngOnInit(): void {

     this.User = JSON.parse(localStorage.getItem("User"));

     if(this.User.AppAccess != null){
      for(var i=0; i < this.User.AppAccess?.length; i++){
          if(this.User.AppAccess[i].Access == true){
            this.HasAppAccess = true;
            break;
          }
      }
    }

     if(this.User == null){
      this.router.navigate(['login'])
     }
     else if(this.User.Rights.AssignedCompanies != null && this.User.Rights.AssignedCompanies.length > 0){
       this.GetUserAssignedCompanies();
     }
     else if(this.User.Rights.AssignedCompanies?.length == 0){
      
        if(this.HasAppAccess == true){
          this.NoCompanyAssignedError = true;
        }
     }
  }

  SelectCompany(company){

    this.User.Rights.AssignedCompanies.forEach(element => {
      if(element.ID == company.ID){
        
        element.IsSelected = true;
      }
      else{
        element.IsSelected = false;
      }
    });

    localStorage.removeItem('User');
    localStorage.setItem('User', JSON.stringify(this.User));
    this.RedirectToURLWithUrlChange('login/MFA');
  }

  RedirectToURLWithUrlChange(url:string){
    this.router.navigate([url], { replaceUrl: true }); 
  }

  GetUserAssignedCompanies(){
  
    var request = {
      User:this.User,
      Language:this.getLanguage(),
    };
  
      this.service.GetUserAssignedCompanies(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else{
          this.User.Rights.AssignedCompanies = response["AssignedCompanies"];
          this.Company = this.User.Rights.AssignedCompanies[0];
          this.GetUserLastUsedCompany();
        }
       
      });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

LogOff() {
  localStorage.removeItem("User");
  this.cookieService.delete("MFAuthToken", "/");
  this.router.navigate(['/login'], { queryParams: {  } });
}

openSnackBar(message: string, action: string, designClass: string) {
  this._snackBar.open(message, action, {
    duration: 5000,
    panelClass: [designClass]
  });
}

GetUserLastUsedCompany(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id
  };

  this.service.GetUserLastUsedCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Company = response["LastUsedCompany"];

      if(!this.Company && this.User.Rights.AssignedCompanies != null && this.User.Rights.AssignedCompanies.length > 0){
        this.User.Rights.AssignedCompanies[0].IsSelected = true;

        localStorage.removeItem('User');
        localStorage.setItem('User', JSON.stringify(this.User));
        
        this.Company = this.User.Rights.AssignedCompanies[0];
      }

      if(this.Company){
        this.SelectCompany(this.Company);
      }
    }
  });
}

}
